import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row"
}
const _hoisted_2 = {
  key: 2,
  class: "row"
}
const _hoisted_3 = ["aria-label"]
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col span-8" }
const _hoisted_6 = { class: "col span-4 targets-col" }
const _hoisted_7 = {
  key: 3,
  class: "row"
}
const _hoisted_8 = { class: "col span-8" }
const _hoisted_9 = {
  key: 0,
  class: "m-0"
}
const _hoisted_10 = { class: "col span-4" }
const _hoisted_11 = {
  key: 4,
  class: "row"
}
const _hoisted_12 = { class: "col span-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RadioGroup = _resolveComponent("RadioGroup")!
  const _component_Banner = _resolveComponent("Banner")!
  const _component_ClusterSelectionFields = _resolveComponent("ClusterSelectionFields")!
  const _component_TargetsList = _resolveComponent("TargetsList")!
  const _component_RcSection = _resolveComponent("RcSection")!
  const _component_RcContentGroup = _resolveComponent("RcContentGroup")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass($props.compact ? 'gap-md' : 'gap-20')
  }, [
    ($data.targetMode !== 'advanced')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_RadioGroup, {
            name: "targetMode",
            "data-testid": "fleet-target-cluster-radio-button",
            value: $options.isLocal ? 'local' : $data.targetMode,
            mode: $props.mode,
            options: $options.targetModeOptions,
            disabled: $options.isView,
            "use-body-text-color": $props.compact,
            "onUpdate:value": $options.selectTargetMode
          }, null, 8, ["value", "mode", "options", "disabled", "use-body-text-color", "onUpdate:value"])
        ]))
      : _createCommentVNode("", true),
    _cache[5] || (_cache[5] = _createTextVNode()),
    ($data.targetMode === 'advanced')
      ? (_openBlock(), _createBlock(_component_Banner, {
          key: 1,
          class: "row",
          color: "warning",
          label: _ctx.t('fleet.clusterTargets.advancedConfigs')
        }, null, 8, ["label"]))
      : _createCommentVNode("", true),
    _cache[6] || (_cache[6] = _createTextVNode()),
    ($data.targetMode === 'clusters' && $props.compact && !$options.isView)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_RcContentGroup, { class: "col span-12" }, {
            default: _withCtx(() => [
              _createVNode(_component_RcSection, {
                expanded: $data.clustersExpanded,
                "onUpdate:expanded": _cache[0] || (_cache[0] = ($event: any) => (($data.clustersExpanded) = $event)),
                title: _ctx.t('fleet.clusterTargets.clusters.title'),
                mode: "with-header",
                type: "secondary",
                expandable: "",
                "data-testid": "fleet-target-clusters-section"
              }, _createSlots({
                default: _withCtx(() => [
                  _cache[2] || (_cache[2] = _createTextVNode()),
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_ClusterSelectionFields, {
                        ref: "selectionFields",
                        variant: "appco",
                        "selected-clusters": $data.selectedClusters,
                        "selected-cluster-groups": $data.selectedClusterGroups,
                        "cluster-selectors": $data.clusterSelectors,
                        "clusters-options": $options.clustersOptions,
                        "cluster-groups-options": $options.clusterGroupsOptions,
                        mode: $props.mode,
                        "is-view": $options.isView,
                        compact: $props.compact,
                        onSelectClusters: $options.selectClusters,
                        onSelectClusterGroups: $options.selectClusterGroups,
                        onAddMatchExpressions: $options.addMatchExpressions,
                        onUpdateMatchExpressions: $options.updateMatchExpressions,
                        onRemoveMatchExpressions: $options.removeMatchExpressions
                      }, null, 8, ["selected-clusters", "selected-cluster-groups", "cluster-selectors", "clusters-options", "cluster-groups-options", "mode", "is-view", "compact", "onSelectClusters", "onSelectClusterGroups", "onAddMatchExpressions", "onUpdateMatchExpressions", "onRemoveMatchExpressions"])
                    ]),
                    _cache[1] || (_cache[1] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_TargetsList, {
                        class: "target-list",
                        clusters: $props.matching,
                        compact: $props.compact,
                        "empty-label": _ctx.t('fleet.clusterTargets.rules.matching.placeholder')
                      }, null, 8, ["clusters", "compact", "empty-label"])
                    ])
                  ])
                ]),
                _: 2
              }, [
                (!$data.clustersExpanded)
                  ? {
                      name: "badges",
                      fn: _withCtx(() => [
                        _createElementVNode("span", {
                          class: "cluster-count-badge",
                          "aria-label": _ctx.t('fleet.clusterTargets.rules.matching.title', { n: $props.matching.length })
                        }, _toDisplayString(_ctx.t('fleet.clusterTargets.rules.matching.title', { n: $props.matching.length })), 9, _hoisted_3)
                      ]),
                      key: "0"
                    }
                  : undefined
              ]), 1032, ["expanded", "title"])
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _cache[7] || (_cache[7] = _createTextVNode()),
    ($data.targetMode === 'clusters' && (!$props.compact || $options.isView))
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            (!$props.compact)
              ? (_openBlock(), _createElementBlock("h3", _hoisted_9, _toDisplayString(_ctx.t('fleet.clusterTargets.clusters.title')), 1))
              : _createCommentVNode("", true),
            _cache[3] || (_cache[3] = _createTextVNode()),
            _createVNode(_component_ClusterSelectionFields, {
              ref: "selectionFields",
              variant: "default",
              "selected-clusters": $data.selectedClusters,
              "selected-cluster-groups": $data.selectedClusterGroups,
              "cluster-selectors": $data.clusterSelectors,
              "clusters-options": $options.clustersOptions,
              "cluster-groups-options": $options.clusterGroupsOptions,
              mode: $props.mode,
              "is-view": $options.isView,
              compact: $props.compact,
              onSelectClusters: $options.selectClusters,
              onSelectClusterGroups: $options.selectClusterGroups,
              onAddMatchExpressions: $options.addMatchExpressions,
              onUpdateMatchExpressions: $options.updateMatchExpressions,
              onRemoveMatchExpressions: $options.removeMatchExpressions
            }, null, 8, ["selected-clusters", "selected-cluster-groups", "cluster-selectors", "clusters-options", "cluster-groups-options", "mode", "is-view", "compact", "onSelectClusters", "onSelectClusterGroups", "onAddMatchExpressions", "onUpdateMatchExpressions", "onRemoveMatchExpressions"])
          ]),
          _cache[4] || (_cache[4] = _createTextVNode()),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_TargetsList, {
              class: "target-list",
              clusters: $props.matching,
              "empty-label": _ctx.t('fleet.clusterTargets.rules.matching.placeholder')
            }, null, 8, ["clusters", "empty-label"])
          ])
        ]))
      : _createCommentVNode("", true),
    _cache[8] || (_cache[8] = _createTextVNode()),
    ($data.targetMode === 'all' && !$options.isLocal && !$props.compact)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_TargetsList, {
              class: "target-list",
              clusters: $props.matching,
              compact: $props.compact
            }, null, 8, ["clusters", "compact"])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}